module.exports = __webpack_public_path__ + "f4b049306a805e29ab1e0ac57a47ec77.png";